const getNameWithId = (name: string, id: string | number) => {
  return `${name} (${id})`;
};
export default getNameWithId;
